import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css';

function Button({
  variant = 'secondary',
  disabled = false,
  to,
  href,
  onClick,
  className,
  children,
  ...rest
}) {
  const base = disabled ? 'button button--disabled' : `button button--${variant}`;
  const classes = className ? `${base} ${className}` : base;

  // aria-disabled (not the native disabled attribute) keeps the control focusable and
  // announced by screen readers, so an unavailable action stays discoverable instead
  // of silently vanishing from the tab order.
  if (disabled) {
    return (
      <span role="button" tabIndex={0} className={classes} aria-disabled="true" {...rest}>
        {children}
      </span>
    );
  }

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button className={classes} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}

export default Button;
